import axios from "axios";
import { useState, useEffect, useMemo } from "react";
import ApiUrl from "./../Environment/ApiUrl";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useToast } from "../Toast/ToastContext";
import "../../assets/css/Loader.css";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";

function User() {
  const toast = useToast();
  const [showModal, setShowModal] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [updateModal, setUpdateModal] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [responseData, setResponseData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [hasLoginCredentials, setHasLoginCredentials] = useState(false);
  const [updateHasLoginCredentials, setUpdateHasLoginCredentials] = useState(false);
  const [isTranslating, setIsTranslating] = useState(false);


  const translateToTamil = async (englishText) => {
  if (!englishText || englishText.trim().length < 2) return "";
  
  setIsTranslating(true);
  
  // Try multiple free translation APIs
  const apis = [
    // MyMemory API (free, no key needed)
    async () => {
      const encoded = encodeURIComponent(englishText.trim());
      const res = await fetch(`https://api.mymemory.translated.net/get?q=${encoded}&langpair=en|ta`);
      const data = await res.json();
      const translated = data?.responseData?.translatedText;
      // Check if translation worked (not just returning the same English text)
      if (translated && translated.toLowerCase() !== englishText.toLowerCase()) {
        return translated;
      }
      return null;
    },
    
    // Lingva Translate (free, no key, uses Google Translate)
    async () => {
      const encoded = encodeURIComponent(englishText.trim());
      const res = await fetch(`https://lingva.ml/api/v1/en/ta/${encoded}`);
      if (res.ok) {
        const data = await res.json();
        if (data.translation && data.translation !== englishText) {
          return data.translation;
        }
      }
      return null;
    },
    
    // Alternative: LibreTranslate (free instance)
    async () => {
      const res = await fetch('https://libretranslate.com/translate', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          q: englishText.trim(),
          source: 'en',
          target: 'ta',
          format: 'text'
        })
      });
      if (res.ok) {
        const data = await res.json();
        if (data.translatedText) {
          return data.translatedText;
        }
      }
      return null;
    }
  ];
  
  // Try APIs in sequence until one works
  for (const api of apis) {
    try {
      const result = await api();
      if (result) {
        setIsTranslating(false);
        return result;
      }
    } catch (error) {
      console.warn("Translation API failed:", error);
      continue;
    }
  }
  
  setIsTranslating(false);
  return ""; // Return empty if all fail
};


  const openModal = () => setShowModal(true);
  const closeModal = () => {
    setShowModal(false);
    setHasLoginCredentials(false);
    setAddData({
      user_id: "",
      name: "",
      name_tamil: "",
      mobile_number: "",
      password: "",
      role: "",
      login_status: "",
      manager_id: "",
      created_by: "",
      created_date: "",
      updated_by: "",
      updated_date: "",
    });
  };

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${ApiUrl}/Api/user.php`);
      console.log("Response from server:", response.data);
      setResponseData(response.data?.data || []);
      setTimeout(() => setLoading(false), 1000);
    } catch (error) {
      console.error("Error fetching data:", error.message);
      setResponseData([]);
      toast.error("Failed to fetch data", 3000, "topRight");
    } finally {
      setTimeout(() => setLoading(false), 1000);
    }
  };

  const [addData, setAddData] = useState({
    user_id: "",
    name: "",
    name_tamil: "",
    mobile_number: "",
    password: "",
    role: "",
    login_status: "",
    manager_id: "",
    created_by: "",
    created_date: "",
    updated_by: "",
    updated_date: "",
  });

  const handlesubmit = async (e) => {
    e.preventDefault();
    const errors = {};
    if (!addData.user_id) errors.user_id = "User ID is required";
    if (!addData.name) errors.name = "Name is required";
    if (!addData.mobile_number)
      errors.mobile_number = "Mobile Number is required";
    else if (!/^\d{10}$/.test(addData.mobile_number))
      errors.mobile_number = "Mobile Number must be exactly 10 digits";
    if (addData.role !== "Employee" && !addData.password)
      errors.password = "Password is required";
    if (addData.role === "Employee" && hasLoginCredentials && !addData.password)
      errors.password = "Password is required";
    if (!addData.role) errors.role = "Role is required";
    if (addData.role === "Employee" && !addData.manager_id)
      errors.manager_id = "Manager is required";
    if (!addData.login_status) errors.login_status = "Status is required";

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    } else {
      setFormErrors({});
    }

    try {
      setLoading(true);
      const checkResponse = await axios.get(`${ApiUrl}/Api/user.php`);
      if (checkResponse.data.status && checkResponse.data.data) {
        const userIdExists = checkResponse.data.data.some(
          (user) => user.user_id === addData.user_id
        );
        if (userIdExists) {
          toast.error("This User ID already exists!", 3000, "topRight");
          setLoading(false);
          return;
        }
      }

      const formData = {
        user_id: addData.user_id,
        name: addData.name,
         name_tamil: addData.name_tamil || "", 
        mobile_number: addData.mobile_number,
        password:
          addData.role === "Employee" && !hasLoginCredentials
            ? ""
            : addData.password,
        role: addData.role,
        login_status: addData.login_status,
        manager_id: addData.role === "Employee" ? addData.manager_id : "",
        created_by: "",
        created_date: "",
        updated_by: "",
        updated_date: "",
      };

      const response = await axios.post(`${ApiUrl}/Api/user.php`, formData);
      console.log("Submit data:", response);
      setShowModal(false);
      setHasLoginCredentials(false);
      setTimeout(() => setLoading(false), 1000);
      toast.success("Added successfully!", 3000, "topRight");
      setAddData({
        user_id: "",
        name: "",
        mobile_number: "",
        password: "",
        role: "",
        login_status: "",
        manager_id: "",
        created_by: "",
        created_date: "",
        updated_by: "",
        updated_date: "",
      });
      fetchData();
    } catch (error) {
      console.error("Error submitting data:", error.message);
      toast.error(
        "An error occurred while submitting the form.",
        3000,
        "topRight"
      );
    } finally {
      setTimeout(() => setLoading(false), 1000);
    }
  };

  const closeUpdateModal = () => {
    setUpdateModal(false);
    setUpdateHasLoginCredentials(false);
    setUpdateData({
      user_id: "",
      name: "",
      name_tamil: "",
      mobile_number: "",
      password: "",
      role: "",
      login_status: "",
      manager_id: "",
      created_by: "",
      created_date: "",
      updated_by: "",
      updated_date: "",
    });
  };

  const [updateData, setUpdateData] = useState({
    user_id: "",
    name: "",
    name_tamil: "",
    mobile_number: "",
    password: "",
    role: "",
    login_status: "",
    manager_id: "",
    created_by: "",
    created_date: "",
    updated_by: "",
    updated_date: "",
  });
  const [updateid, setUpdateId] = useState("");

  const handleUpdate = (id, data) => {
    setUpdateId(id);
    console.log("The data to update", data);
    setUpdateModal(true);
    setUpdateHasLoginCredentials(data.password !== "");
    setUpdateData({
      user_id: data.user_id,
      name: data.name,
      name_tamil: data.name_tamil || "",
      mobile_number: data.mobile_number,
      password: data.password,
      role: data.role,
      login_status: data.login_status,
      manager_id: data.manager_id || "",
      created_by: "",
      created_date: "",
      updated_by: "",
      updated_date: "",
    });
  };

  const handleupdatesubmit = async (e) => {
    e.preventDefault();
    const errors = {};
    if (!updateData.user_id) errors.user_id = "User ID is required";
    if (!updateData.name) errors.name = "Name is required";
    if (!updateData.mobile_number)
      errors.mobile_number = "Mobile Number is required";
    else if (!/^\d{10}$/.test(updateData.mobile_number))
      errors.mobile_number = "Mobile Number must be exactly 10 digits";
    if (updateData.role !== "Employee" && !updateData.password)
      errors.password = "Password is required";
    if (
      updateData.role === "Employee" &&
      updateHasLoginCredentials &&
      !updateData.password
    )
      errors.password = "Password is required";
    if (!updateData.role) errors.role = "Role is required";
    if (updateData.role === "Employee" && !updateData.manager_id)
      errors.manager_id = "Manager is required";
    if (!updateData.login_status) errors.login_status = "Status is required";

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    } else {
      setFormErrors({});
    }

    try {
      setLoading(true);
      const formData = {
        user_id: updateData.user_id,
        name: updateData.name,
        name_tamil: updateData.name_tamil || "",
        mobile_number: updateData.mobile_number,
        password:
          updateData.role === "Employee" && !updateHasLoginCredentials
            ? ""
            : updateData.password,
        role: updateData.role,
        login_status: updateData.login_status,
        manager_id: updateData.role === "Employee" ? updateData.manager_id : "",
        created_by: "",
        created_date: "",
        updated_by: "",
        updated_date: "",
      };
      console.log("The update submit data", formData);
      const response = await axios.put(
        `${ApiUrl}/Api/user.php/${updateid}`,
        formData
      );
      console.log("Response for update", response);
      setUpdateModal(false);
      setUpdateHasLoginCredentials(false);
      setTimeout(() => setLoading(false), 1000);
      toast.success("Updated successfully!", 3000, "topRight");
      fetchData();
    } catch (error) {
      console.error("Error updating data:", error.message);
      toast.error("Failed to update data", 3000, "topRight");
    } finally {
      setTimeout(() => setLoading(false), 1000);
    }
  };

  const [deleteShowModals, setDeleteShowModals] = useState(false);
  const [getdeleteid, setdeleteid] = useState("");
  const [getdeletename, setdeletename] = useState("");

  const handleOpenModal = (id, name) => {
    setdeleteid(id);
    setdeletename(name);
    setDeleteShowModals(true);
  };

  const handleCloseModal = () => {
    setDeleteShowModals(false);
  };

  const handleDelete = async () => {
    try {
      setLoading(true);
      const response = await axios.delete(
        `${ApiUrl}/Api/user.php/${getdeleteid}`
      );
      console.log("Delete data ", response);
      setDeleteShowModals(false);
      setTimeout(() => setLoading(false), 1000);
      toast.success("deleted successfully!", 3000, "topRight");
      fetchData();
    } catch (error) {
      console.error("Error soft-deleting data:", error.message);
      toast.error("Failed to soft-delete data", 3000, "topRight");
    } finally {
      setTimeout(() => setLoading(false), 1000);
    }
  };

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [showAllItems, setShowAllItems] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const userMap = useMemo(
    () => new Map(responseData.map((u) => [u.user_id, u.name])),
    [responseData]
  );

  const filteredData = responseData.filter((item) => {
    const searchLower = searchTerm.toLowerCase();
    return (
      (item.user_id && item.user_id.toLowerCase().includes(searchLower)) ||
      (item.name && item.name.toLowerCase().includes(searchLower)) ||
      (item.mobile_number &&
        item.mobile_number.toString().includes(searchLower)) ||
      (item.role && item.role.toLowerCase().includes(searchLower)) ||
      (item.login_status && item.login_status.toString().includes(searchLower)) ||
      (item.manager_id &&
        item.role === "Employee" &&
        userMap.get(item.manager_id)?.toLowerCase().includes(searchLower))
    );
  });

  const totalItems = filteredData.length;
  const totalPages = showAllItems ? 1 : Math.ceil(totalItems / itemsPerPage);
  const currentItems = showAllItems
    ? filteredData
    : filteredData.slice(
      (currentPage - 1) * itemsPerPage,
      currentPage * itemsPerPage
    );

  const handlePageChange = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
  };

  const handleItemsPerPageChange = (e) => {
    const value = e.target.value;
    if (value === "All") {
      setShowAllItems(true);
      setCurrentPage(1);
    } else {
      setShowAllItems(false);
      setItemsPerPage(Number(value));
      setCurrentPage(1);
    }
  };

  const renderPageNumbers = () => {
    const pages = [];
    const maxVisiblePages = 2;
    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    if (startPage > 1) {
      pages.push(
        <li
          key={1}
          className={`page-item ${currentPage === 1 ? "active" : ""}`}
        >
          <button className="page-link" onClick={() => handlePageChange(1)}>
            1
          </button>
        </li>
      );
      if (startPage > 2) {
        pages.push(
          <li key="start-ellipsis" className="page-item disabled">
            <span className="page-link">...</span>
          </li>
        );
      }
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <li
          key={i}
          className={`page-item ${currentPage === i ? "active" : ""}`}
        >
          <button className="page-link" onClick={() => handlePageChange(i)}>
            {i}
          </button>
        </li>
      );
    }

    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        pages.push(
          <li key="end-ellipsis" className="page-item disabled">
            <span className="page-link">...</span>
          </li>
        );
      }
      pages.push(
        <li
          key={totalPages}
          className={`page-item ${currentPage === totalPages ? "active" : ""}`}
        >
          <button
            className="page-link"
            onClick={() => handlePageChange(totalPages)}
          >
            {totalPages}
          </button>
        </li>
      );
    }

    return pages;
  };

  const handlePrint = () => {
    const userMap = new Map(responseData.map((u) => [u.user_id, u.name]));
    const printWindow = window.open("", "_blank");
    const printContent = `
      <!DOCTYPE html>
      <html>
        <head>
          <title>Users Report</title>
          <style>
            body { font-family: Arial, sans-serif; margin: 20px; }
            .header { text-align: center; margin-bottom: 30px; }
            .header h1 { color: #333; margin-bottom: 10px; }
            .header p { color: #666; margin: 0; }
            table { width: 100%; border-collapse: collapse; margin-top: 20px; }
            th, td { border: 1px solid #ddd; padding: 12px; text-align: left; }
            th { background-color: #f8f9fa; font-weight: bold; color: #333; }
            tr:nth-child(even) { background-color: #f9f9f9; }
            .status-active { background-color: #d4edda; color: #155724; padding: 4px 8px; border-radius: 4px; }
            .status-inactive { background-color: #f8d7da; color: #721c24; padding: 4px 8px; border-radius: 4px; }
            .footer { margin-top: 30px; text-align: center; color: #666; font-size: 12px; }
            @media print {
              body { margin: 0; }
              .header { margin-bottom: 20px; }
            }
          </style>
        </head>
        <body>
          <div class="header">
            <h1>Users Report</h1>
            <p>Generated on ${new Date().toLocaleDateString()} at ${new Date().toLocaleTimeString()}</p>
            <p>Total Records: ${filteredData.length}</p>
          </div>
          <table>
            <thead>
              <tr>
                <th>S.No</th>
                <th>User ID</th>
                <th>Name</th>
                <th>Mobile Number</th>
                <th>Role</th>
                <th>Manager</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              ${filteredData
        .map(
          (item, index) => `
                <tr>
                  <td>${index + 1}</td>
                  <td>${item.user_id || ""}</td>
                  <td>${item.name || ""}${item.name_tamil ? ` / ${item.name_tamil}` : ""}</td>
                  <td>${item.mobile_number || ""}</td>
                  <td>${item.role || ""}</td>
                  <td>${item.role === "Employee" ? userMap.get(item.manager_id) || "" : ""
            }</td>
                  <td>
                    <span class="${item.login_status === "Active"
              ? "status-active"
              : "status-inactive"
            }">
                      ${item.login_status || ""}
                    </span>
                  </td>
                </tr>
              `
        )
        .join("")}
            </tbody>
          </table>
          <div class="footer">
            <p>This report contains ${filteredData.length} user records</p>
          </div>
        </body>
      </html>
    `;
    printWindow.document.write(printContent);
    printWindow.document.close();
    setTimeout(() => {
      printWindow.print();
      printWindow.close();
    }, 250);
  };

  const exportPDF = () => {
    try {
      const userMap = new Map(responseData.map((u) => [u.user_id, u.name]));
      const doc = new jsPDF();
      doc.setFontSize(18);
      doc.setTextColor(40, 40, 40);
      doc.text("Users Report", 14, 22);
      doc.setFontSize(11);
      doc.setTextColor(100, 100, 100);
      doc.text(
        `Generated on: ${new Date().toLocaleDateString()} ${new Date().toLocaleTimeString()}`,
        14,
        32
      );
      doc.text(`Total Records: ${filteredData.length}`, 14, 40);
      const tableColumn = [
        "S.No",
        "User ID",
        "Name",
        "Mobile Number",
        "Role",
        "Manager",
        "Status",
      ];
      const tableRows = filteredData.map((item, index) => [
        index + 1,
        item.user_id || "",
        item.name || "",
        item.mobile_number || "",
        item.role || "",
        item.role === "Employee" ? userMap.get(item.manager_id) || "" : "",
        item.login_status || "",
      ]);
      autoTable(doc, {
        head: [tableColumn],
        body: tableRows,
        startY: 50,
        styles: { fontSize: 9, cellPadding: 3 },
        headStyles: {
          fillColor: [41, 128, 185],
          textColor: 255,
          fontStyle: "bold",
        },
        alternateRowStyles: { fillColor: [245, 245, 245] },
        margin: { top: 50, left: 14, right: 14 },
      });
      doc.save(`Users_Report_${new Date().toISOString().split("T")[0]}.pdf`);
      toast.success("PDF exported successfully!", 3000, "topRight");
    } catch (error) {
      console.error("Error generating PDF:", error);
      toast.error("Failed to export PDF", 3000, "topRight");
    }
  };

  const copyToClipboard = () => {
    try {
      const userMap = new Map(responseData.map((u) => [u.user_id, u.name]));
      const headers = [
        "S.No",
        "User ID",
        "Name",
        "Mobile Number",
        "Role",
        "Manager",
        "Status",
      ];
      const rows = (filteredData || []).map((item, index) => [
        index + 1,
        item?.user_id || "",
        item?.name || "",
        item?.mobile_number || "",
        item?.role || "",
        item.role === "Employee" ? userMap.get(item?.manager_id) || "" : "",
        item?.login_status || "",
      ]);
      const csvData = [headers, ...rows]
        .map((row) => row.join("\t"))
        .join("\n");
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard
          .writeText(csvData)
          .then(() => {
            toast.success("Data copied to clipboard!", 3000, "topRight");
          })
          .catch((err) => {
            console.error("Clipboard API failed:", err);
            fallbackCopy(csvData);
          });
      } else {
        fallbackCopy(csvData);
      }
    } catch (error) {
      console.error("Unexpected error copying to clipboard:", error);
      toast.error("Failed to copy data", 3000, "topRight");
    }
  };

  const fallbackCopy = (text) => {
    try {
      const textArea = document.createElement("textarea");
      textArea.value = text;
      textArea.style.position = "fixed";
      textArea.style.top = "0";
      textArea.style.left = "0";
      textArea.style.width = "2em";
      textArea.style.height = "2em";
      textArea.style.padding = "0";
      textArea.style.border = "none";
      textArea.style.outline = "none";
      textArea.style.boxShadow = "none";
      textArea.style.background = "transparent";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      const successful = document.execCommand("copy");
      document.body.removeChild(textArea);
      if (successful) {
        toast.success("Data copied using fallback!", 3000, "topRight");
      } else {
        throw new Error("Fallback copy failed");
      }
    } catch (err) {
      console.error("Fallback copy failed:", err);
      toast.error("Failed to copy data", 3000, "topRight");
    }
  };

  const exportCSV = () => {
    try {
      const userMap = new Map(responseData.map((u) => [u.user_id, u.name]));
      const headers = [
        "S.No",
        "User ID",
        "Name",
        "Mobile Number",
        "Role",
        "Manager",
        "Status",
      ];
      const rows = filteredData.map((item, index) => [
        index + 1,
        item.user_id || "",
        item.name || "",
        item.mobile_number || "",
        item.role || "",
        item.role === "Employee" ? userMap.get(item.manager_id) || "" : "",
        item.login_status || "",
      ]);
      const csvContent = [headers, ...rows]
        .map((row) => row.map((field) => `"${field}"`).join(","))
        .join("\n");
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute(
        "download",
        `Users_Report_${new Date().toISOString().split("T")[0]}.csv`
      );
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      toast.success("CSV exported successfully!", 3000, "topRight");
    } catch (error) {
      console.error("Error generating CSV:", error);
      toast.error("Failed to export CSV", 3000, "topRight");
    }
  };

  const exportExcel = () => {
    try {
      const userMap = new Map(responseData.map((u) => [u.user_id, u.name]));
      const headers = [
        "S.No",
        "User ID",
        "Name",
        "Mobile Number",
        "Role",
        "Manager",
        "Status",
      ];
      const rows = filteredData.map((item, index) => [
        index + 1,
        item.user_id || "",
        item.name || "",
        item.mobile_number || "",
        item.role || "",
        item.role === "Employee" ? userMap.get(item.manager_id) || "" : "",
        item.login_status || "",
      ]);
      const worksheetData = [headers, ...rows];
      const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
      const colWidths = [
        { wch: 8 },
        { wch: 15 },
        { wch: 20 },
        { wch: 18 },
        { wch: 15 },
        { wch: 20 },
        { wch: 12 },
      ];
      worksheet["!cols"] = colWidths;
      const headerStyle = {
        font: { bold: true, color: { rgb: "FFFFFF" } },
        fill: { fgColor: { rgb: "2980B9" } },
        alignment: { horizontal: "center", vertical: "center" },
      };
      headers.forEach((_, index) => {
        const cellRef = XLSX.utils.encode_cell({ r: 0, c: index });
        if (worksheet[cellRef]) {
          worksheet[cellRef].s = headerStyle;
        }
      });
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Users");
      workbook.Props = {
        Title: "Users Report",
        Subject: "User Management Data",
        Author: "User Management System",
        CreatedDate: new Date(),
      };
      XLSX.writeFile(
        workbook,
        `Users_Report_${new Date().toISOString().split("T")[0]}.xlsx`
      );
      toast.success("Excel exported successfully!", 3000, "topRight");
    } catch (error) {
      console.error("Error generating Excel:", error);
      toast.error("Failed to export Excel", 3000, "topRight");
    }
  };

  return (
    <>
      {loading && (
        <div className="loading-overlay">
          <div className="loading-message">
            <div className="loadinggif"></div>
          </div>
        </div>
      )}
      <div className="container-fluid py-3">
        <div className="d-flex mb-4">
          <h6 className="card-title m-2">Users</h6>
          <button
            className="btn btn-primary btn-sm rounded-3"
            onClick={openModal}
          >
            Add <span className="ms-2">+</span>
          </button>
        </div>
        <div className="card shadow-sm mb-5">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <div className="d-flex">
                <label className="form-label text-dark mt-2">Show : </label>
                <div>
                  <select
                    className="form-control mx-2"
                    onChange={handleItemsPerPageChange}
                    value={showAllItems ? "All" : itemsPerPage}
                  >
                    <option value="All">All</option>
                    {[5, 10, 20, 100, 200, 500, 1000].map((pageSize) => (
                      <option key={pageSize} value={pageSize}>
                        {pageSize}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="d-flex justify-content-center">
                <button
                  className="btn btn-sm btn-info text-white mx-1"
                  onClick={handlePrint}
                >
                  Print
                </button>
                <button
                  className="btn btn-sm btn-info text-white mx-1"
                  onClick={exportPDF}
                >
                  PDF
                </button>
                <button
                  className="btn btn-sm btn-info text-white mx-1"
                  onClick={copyToClipboard}
                >
                  Copy
                </button>
                <button
                  className="btn btn-sm btn-info text-white mx-1"
                  onClick={exportCSV}
                >
                  CSV
                </button>
                <button
                  className="btn btn-sm btn-info text-white mx-1"
                  onClick={exportExcel}
                >
                  Excel
                </button>
              </div>
              <div className="search-container">
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search"
                    aria-label="Search"
                    value={searchTerm}
                    onChange={(e) => {
                      setSearchTerm(e.target.value);
                      setCurrentPage(1);
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="card tableCard p-2">
              <div className="table-container">
                <table className="table table-layout-fixed w-100">
                  <thead className="bg-light">
                    <tr>
                      <th style={{ width: "50px" }}>S.No</th>
                      <th>User Id</th>
                      <th style={{ width: "250px" }}>Name</th>
                      <th>Mobile Number</th>
                      <th>Role</th>
                      <th>Manager</th>
                      <th>Status</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Array.isArray(responseData) &&
                      currentItems.map((item, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{item.user_id}</td>
                          <td>
  {item.name}
  {item.name_tamil && (
    <span className="text-muted"> / {item.name_tamil}</span>
  )}
</td>
                          <td>{item.mobile_number}</td>
                          <td>{item.role}</td>
                          <td>
                            {item.role === "Employee"
                              ? userMap.get(item.manager_id) || "-"
                              : "-"}
                          </td>
                          <td>
                            {item.login_status === "Active" ? (
                              <span className="badge bg-success text-white">
                                Active
                              </span>
                            ) : item.login_status === "Inactive" ? (
                              <span className="badge bg-danger text-white">
                                Inactive
                              </span>
                            ) : (
                              <span className="badge bg-secondary text-white">
                                {item.login_status}
                              </span>
                            )}
                          </td>
                          <td>
                            <button
                              className="btn btn-sm btn-light me-1"
                              onClick={() => handleUpdate(item.id, item)}
                            >
                              <i className="fa-solid fa-pen-to-square text-primary fs-6"></i>
                            </button>
                            <button
                              className="btn btn-sm btn-light"
                              onClick={() =>
                                handleOpenModal(item.id, item.name)
                              }
                            >
                              <i className="fa-solid fa-trash text-danger fs-6"></i>
                            </button>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
              <div className="row">
                <div className="col-lg-6">
                  <p className="text-muted">
                    Showing{" "}
                    {showAllItems ? 1 : (currentPage - 1) * itemsPerPage + 1} to{" "}
                    {showAllItems
                      ? totalItems
                      : Math.min(currentPage * itemsPerPage, totalItems)}{" "}
                    of {totalItems} entries
                  </p>
                </div>
                <div className="col-lg-6">
                  <nav aria-label="Page navigation">
                    <ul className="pagination justify-content-end">
                      <li
                        className={`page-item ${currentPage === 1 ? "disabled" : ""
                          }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(1)}
                          aria-label="First"
                        >
                          <span aria-hidden="true">&laquo;&laquo;</span>
                        </button>
                      </li>
                      <li
                        className={`page-item ${currentPage === 1 ? "disabled" : ""
                          }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(currentPage - 1)}
                          aria-label="Previous"
                        >
                          <span aria-hidden="true">&laquo;</span>
                        </button>
                      </li>
                      {renderPageNumbers()}
                      <li
                        className={`page-item ${currentPage === totalPages || totalPages === 0
                            ? "disabled"
                            : ""
                          }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(currentPage + 1)}
                          aria-label="Next"
                        >
                          <span aria-hidden="true">&raquo;</span>
                        </button>
                      </li>
                      <li
                        className={`page-item ${currentPage === totalPages || totalPages === 0
                            ? "disabled"
                            : ""
                          }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(totalPages)}
                          aria-label="Last"
                        >
                          <span aria-hidden="true">&raquo;&raquo;</span>
                        </button>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className={`modal fade ${showModal ? "show" : ""}`}
        style={{ display: showModal ? "block" : "none" }}
        tabIndex="-1"
        aria-labelledby="addCustomerModalLabel"
        aria-hidden={!showModal}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h6
                className="modal-title text-primary"
                id="addCustomerModalLabel"
              >
                Add User
              </h6>
              <button
                type="button"
                className="btn-close"
                style={{ fontSize: "10px" }}
                onClick={closeModal}
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <form onSubmit={handlesubmit}>
                <div className="row">
                  <div className="col-lg-6">
                    <div className="mb-3">
                      <label htmlFor="user_id" className="form-label">
                        User ID
                      </label>
                      <input
                        type="text"
                        className={`form-control ${formErrors.user_id ? "is-invalid" : ""
                          }`}
                        id="user_id"
                        name="user_id"
                        value={addData.user_id}
                        placeholder="Enter User_ID"
                        onChange={(e) =>
                          setAddData({ ...addData, user_id: e.target.value })
                        }
                        required
                      />
                      {formErrors.user_id && (
                        <div className="invalid-feedback">
                          {formErrors.user_id}
                        </div>
                      )}
                    </div>
                    <div className="mb-3">
  <label htmlFor="name" className="form-label">Name</label>
  <div className="input-group">
    <input
      type="text"
      className={`form-control ${formErrors.name ? "is-invalid" : ""}`}
      id="name"
      placeholder="Enter Name (Tamil will auto-translate)"
      value={addData.name}
      onChange={(e) =>
        setAddData({ ...addData, name: e.target.value, name_tamil: "" })
      }
      onBlur={async (e) => {
        const val = e.target.value.trim();
        if (val && !addData.name_tamil) {
          const tamil = await translateToTamil(val);
          if (tamil) setAddData(prev => ({ ...prev, name_tamil: tamil }));
        }
      }}
      required
    />
    <button
      type="button"
      className="btn btn-outline-secondary"
      disabled={isTranslating || !addData.name}
      onClick={async () => {
        const tamil = await translateToTamil(addData.name);
        if (tamil) {
          setAddData(prev => ({ ...prev, name_tamil: tamil }));
          toast.success("Translated!", 1500, "topRight");
        }
      }}
    >
      {isTranslating ? <span className="spinner-border spinner-border-sm" /> : "🌐 தமிழ்"}
    </button>
  </div>
  {addData.name_tamil && (
    <small className="text-muted mt-1 d-block">
      <strong>Tamil:</strong> {addData.name_tamil}
      <button type="button" className="btn btn-link btn-sm p-0 ms-2 text-muted"
        onClick={() => setAddData(prev => ({ ...prev, name_tamil: "" }))}>
        ✕ clear
      </button>
    </small>
  )}
  {formErrors.name && <div className="invalid-feedback">{formErrors.name}</div>}
</div>
                  </div>
                  <div className="col-lg-6">
                    <div className="mb-3">
                      <label htmlFor="mobile" className="form-label">
                        Mobile Number
                      </label>
                      <input
                        type="text"
                        inputMode="numeric"
                        pattern="[0-9]*"
                        maxLength="10"
                        className={`form-control ${formErrors.mobile_number ? "is-invalid" : ""
                          }`}
                        id="mobile"
                        value={addData.mobile_number}
                        placeholder="Enter Mobile Number"
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^\d{0,10}$/.test(value)) {
                            setAddData({ ...addData, mobile_number: value });
                          }
                        }}
                        required
                      />
                      {formErrors.mobile_number && (
                        <div className="invalid-feedback">
                          {formErrors.mobile_number}
                        </div>
                      )}
                    </div>
                    {(addData.role !== "Employee" || hasLoginCredentials) && (
                      <div className="mb-3">
                        <label htmlFor="password" className="form-label">
                          Password
                        </label>
                        <div
                          className="input-group"
                          style={{ maxWidth: "300px" }}
                        >
                          <input
                            type={showPassword ? "text" : "password"}
                            className={`form-control form-control-sm ${formErrors.password ? "is-invalid" : ""
                              }`}
                            placeholder="Enter Password"
                            value={addData.password}
                            onChange={(e) =>
                              setAddData({
                                ...addData,
                                password: e.target.value,
                              })
                            }
                            required={addData.role !== "Employee" || hasLoginCredentials}
                            style={{ height: "32px" }}
                          />
                          <span
                            className="input-group-text"
                            style={{
                              cursor: "pointer",
                              padding: "0.375rem",
                              height: "32px",
                            }}
                            onClick={() => setShowPassword(!showPassword)}
                          >
                            <FontAwesomeIcon
                              size="sm"
                              icon={showPassword ? faEyeSlash : faEye}
                            />
                          </span>
                          {formErrors.password && (
                            <div className="invalid-feedback d-block">
                              {formErrors.password}
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className="mb-3">
                  <label htmlFor="role" className="form-label">
                    Role
                  </label>
                  <select
                    className={`form-select ${formErrors.role ? "is-invalid" : ""
                      }`}
                    id="role"
                    value={addData.role}
                    onChange={(e) => {
                      const role = e.target.value;
                      setAddData({
                        ...addData,
                        role,
                        login_status: role === "Employee" ? "Inactive" : "",
                        password: role === "Employee" ? "" : addData.password,
                        manager_id: role === "Employee" ? addData.manager_id : "",
                      });
                      if (role === "Employee") setHasLoginCredentials(false);
                    }}
                    required
                  >
                    <option value="" disabled>
                      Select Role
                    </option>
                    <option value="Admin">Admin</option>
                    <option value="Manager">Manager</option>
                    <option value="Employee">Employee</option>
                  </select>
                  {formErrors.role && (
                    <div className="invalid-feedback">{formErrors.role}</div>
                  )}
                </div>
                {addData.role === "Employee" && (
                  <div className="mb-3">
                    <label className="form-label">Password Credentials</label>
                    <div className="form-check">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="hasLoginCredentials"
                        checked={hasLoginCredentials}
                        onChange={(e) => {
                          const checked = e.target.checked;
                          setHasLoginCredentials(checked);
                          setAddData({
                            ...addData,
                            login_status: checked ? "Active" : "Inactive",
                            password: checked ? addData.password : "",
                          });
                        }}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="hasLoginCredentials"
                      >
                        Provide login credentials
                      </label>
                    </div>
                  </div>
                )}
                {addData.role === "Employee" && (
                  <div className="mb-3">
                    <label htmlFor="manager_id" className="form-label">
                      Manager
                    </label>
                    <select
                      className={`form-select ${formErrors.manager_id ? "is-invalid" : ""
                        }`}
                      id="manager_id"
                      value={addData.manager_id}
                      onChange={(e) =>
                        setAddData({ ...addData, manager_id: e.target.value })
                      }
                      required
                    >
                      <option value="" disabled>
                        Select Manager
                      </option>
                      {responseData
                        .filter(
                          (u) =>
                            u.role === "Manager" && u.login_status === "Active"
                        )
                        .map((u) => (
                          <option key={u.user_id} value={u.user_id}>
                            {u.name}
                          </option>
                        ))}
                    </select>
                    {formErrors.manager_id && (
                      <div className="invalid-feedback">
                        {formErrors.manager_id}
                      </div>
                    )}
                  </div>
                )}
                <div className="mb-3">
                  <label htmlFor="customerStatus" className="form-label">
                    Status
                  </label>
                  <select
                    className={`form-select ${formErrors.login_status ? "is-invalid" : ""
                      }`}
                    id="customerStatus"
                    value={addData.login_status}
                    onChange={(e) =>
                      setAddData({ ...addData, login_status: e.target.value })
                    }
                    disabled={addData.role === "Employee"}
                    required
                  >
                    <option value="" disabled>
                      Select Status
                    </option>
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                  </select>
                  {formErrors.login_status && (
                    <div className="invalid-feedback">
                      {formErrors.login_status}
                    </div>
                  )}
                </div>
                <div className="text-center mt-4">
                  <button
                    type="submit"
                    className="btn btn-primary btn-sm px-4"
                    disabled={loading}
                  >
                    {loading ? "Submitting..." : "Submit"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div
        className={`modal fade ${updateModal ? "show" : ""}`}
        style={{ display: updateModal ? "block" : "none" }}
        tabIndex="-1"
        aria-labelledby="updateCustomerModalLabel"
        aria-hidden={!updateModal}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h6
                className="modal-title text-primary"
                id="updateCustomerModalLabel"
              >
                Update User
              </h6>
              <button
                type="button"
                className="btn-close"
                style={{ fontSize: "10px" }}
                onClick={closeUpdateModal}
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <form>
                <div className="row">
                  <div className="col-lg-6">
                    <div className="mb-3">
                      <label htmlFor="user_id" className="form-label">
                        User Id
                      </label>
                      <input
                        type="text"
                        className={`form-control ${formErrors.user_id ? "is-invalid" : ""
                          }`}
                        id="user_id"
                        name="user_id"
                        placeholder="Enter user_id"
                        value={updateData.user_id}
                        onChange={(e) =>
                          setUpdateData({
                            ...updateData,
                            user_id: e.target.value,
                          })
                        }
                        required
                        readOnly
                        disabled
                      />
                      {formErrors.user_id && (
                        <div className="invalid-feedback">
                          {formErrors.user_id}
                        </div>
                      )}
                    </div>
 <div className="mb-3">
  <label htmlFor="name" className="form-label">Name</label>
  <div className="input-group">
    <input
      type="text"
      className={`form-control ${formErrors.name ? "is-invalid" : ""}`}
      id="name"
      value={updateData.name}
      onChange={(e) =>
        setUpdateData({ ...updateData, name: e.target.value, name_tamil: "" })
      }
      onBlur={async (e) => {
        const val = e.target.value.trim();
        if (val) {
          const tamil = await translateToTamil(val);
          if (tamil) setUpdateData(prev => ({ ...prev, name_tamil: tamil }));
        }
      }}
      required
    />
    <button
      type="button"
      className="btn btn-outline-secondary"
      disabled={isTranslating || !updateData.name}
      onClick={async () => {
        const tamil = await translateToTamil(updateData.name);
        if (tamil) setUpdateData(prev => ({ ...prev, name_tamil: tamil }));
      }}
    >
      {isTranslating ? <span className="spinner-border spinner-border-sm" /> : "🌐 தமிழ்"}
    </button>
  </div>
  {updateData.name_tamil && (
    <small className="text-muted mt-1 d-block">
      <strong>Tamil:</strong> {updateData.name_tamil}
      <button type="button" className="btn btn-link btn-sm p-0 ms-2 text-muted"
        onClick={() => setUpdateData(prev => ({ ...prev, name_tamil: "" }))}>
        ✕ clear
      </button>
    </small>
  )}
  {formErrors.name && <div className="invalid-feedback">{formErrors.name}</div>}
</div>
                  </div>
                  <div className="col-lg-6">
                    <div className="mb-3">
                      <label htmlFor="mobile" className="form-label">
                        Mobile Number
                      </label>
                      <input
                        type="text"
                        inputMode="numeric"
                        pattern="[0-9]*"
                        maxLength="10"
                        className={`form-control ${formErrors.mobile_number ? "is-invalid" : ""
                          }`}
                        id="mobile"
                        value={updateData.mobile_number}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^\d{0,10}$/.test(value)) {
                            setUpdateData({
                              ...updateData,
                              mobile_number: value,
                            });
                          }
                        }}
                        placeholder="Enter Mobile Number"
                        required
                      />
                      {formErrors.mobile_number && (
                        <div className="invalid-feedback">
                          {formErrors.mobile_number}
                        </div>
                      )}
                    </div>
                    {(updateData.role !== "Employee" || updateHasLoginCredentials) && (
                      <div className="mb-3">
                        <label htmlFor="password" className="form-label">
                          Password
                        </label>
                        <div
                          className="input-group"
                          style={{ maxWidth: "300px" }}
                        >
                          <input
                            type={showPassword ? "text" : "password"}
                            className={`form-control form-control-sm ${formErrors.password ? "is-invalid" : ""
                              }`}
                            placeholder="Enter Password"
                            value={updateData.password}
                            onChange={(e) =>
                              setUpdateData({
                                ...updateData,
                                password: e.target.value,
                              })
                            }
                            required={updateData.role !== "Employee" || updateHasLoginCredentials}
                            style={{ height: "32px" }}
                          />
                          <span
                            className="input-group-text"
                            style={{
                              cursor: "pointer",
                              padding: "0.375rem",
                              height: "32px",
                            }}
                            onClick={() => setShowPassword(!showPassword)}
                          >
                            <FontAwesomeIcon
                              size="sm"
                              icon={showPassword ? faEyeSlash : faEye}
                            />
                          </span>
                          {formErrors.password && (
                            <div className="invalid-feedback d-block">
                              {formErrors.password}
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className="mb-3">
                  <label htmlFor="role" className="form-label">
                    Role
                  </label>
                  <select
                    className={`form-select ${formErrors.role ? "is-invalid" : ""
                      }`}
                    id="role"
                    value={updateData.role}
                    onChange={(e) => {
                      const role = e.target.value;
                      setUpdateData({
                        ...updateData,
                        role,
                        login_status: role === "Employee" ? (updateHasLoginCredentials ? "Active" : "Inactive") : updateData.login_status,
                        password: role === "Employee" ? (updateHasLoginCredentials ? updateData.password : "") : updateData.password,
                        manager_id: role === "Employee" ? updateData.manager_id : "",
                      });
                      if (role === "Employee" && !updateHasLoginCredentials) {
                        setUpdateHasLoginCredentials(false);
                      }
                    }}
                    required
                  >
                    <option value="" disabled>
                      Select Role
                    </option>
                    <option value="Admin">Admin</option>
                    <option value="Manager">Manager</option>
                    <option value="Employee">Employee</option>
                  </select>
                  {formErrors.role && (
                    <div className="invalid-feedback">{formErrors.role}</div>
                  )}
                </div>
                {updateData.role === "Employee" && (
                  <div className="mb-3">
                    <label className="form-label">Password Credentials</label>
                    <div className="form-check">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="updateHasLoginCredentials"
                        checked={updateHasLoginCredentials}
                        onChange={(e) => {
                          const checked = e.target.checked;
                          setUpdateHasLoginCredentials(checked);
                          setUpdateData({
                            ...updateData,
                            login_status: checked ? "Active" : "Inactive",
                            password: checked ? updateData.password : "",
                          });
                        }}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="updateHasLoginCredentials"
                      >
                        Provide login credentials
                      </label>
                    </div>
                  </div>
                )}
                {updateData.role === "Employee" && (
                  <div className="mb-3">
                    <label htmlFor="manager_id" className="form-label">
                      Manager
                    </label>
                    <select
                      className={`form-select ${formErrors.manager_id ? "is-invalid" : ""
                        }`}
                      id="manager_id"
                      value={updateData.manager_id}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          manager_id: e.target.value,
                        })
                      }
                      required
                    >
                      <option value="" disabled>
                        Select Manager
                      </option>
                      {responseData
                        .filter(
                          (u) =>
                            u.role === "Manager" && u.login_status === "Active"
                        )
                        .map((u) => (
                          <option key={u.user_id} value={u.user_id}>
                            {u.name}
                          </option>
                        ))}
                    </select>
                    {formErrors.manager_id && (
                      <div className="invalid-feedback">
                        {formErrors.manager_id}
                      </div>
                    )}
                  </div>
                )}
                <div className="mb-3">
                  <label htmlFor="customerStatus" className="form-label">
                    Status
                  </label>
                  <select
                    className={`form-select ${formErrors.login_status ? "is-invalid" : ""
                      }`}
                    id="customerStatus"
                    value={updateData.login_status}
                    onChange={(e) =>
                      setUpdateData({
                        ...updateData,
                        login_status: e.target.value,
                      })
                    }
                    disabled={updateData.role === "Employee"}
                    required
                  >
                    <option value="" disabled>
                      Select Status
                    </option>
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                  </select>
                  {formErrors.login_status && (
                    <div className="invalid-feedback">
                      {formErrors.login_status}
                    </div>
                  )}
                </div>
                <div className="text-center mt-4">
                  <button
                    type="submit"
                    className="btn btn-primary btn-sm px-4"
                    onClick={handleupdatesubmit}
                  >
                    Update
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div
        className={`modal fade ${deleteShowModals ? "show" : ""}`}
        style={{
          display: deleteShowModals ? "block" : "none",
          backgroundColor: "rgba(0,0,0,0.5)",
        }}
        tabIndex="-1"
        aria-labelledby="deleteConfirmModalLabel"
        aria-modal="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-confirm">
          <div className="modal-content">
            <div className="modal-body text-center">
              <div className="d-flex justify-content-center mb-3">
                <div
                  className="icon-box d-flex justify-content-center align-items-center bg-light rounded-circle"
                  style={{ width: "80px", height: "50px", margin: "0 auto" }}
                >
                  <i className="bi bi-exclamation-triangle text-danger fs-2"></i>
                </div>
              </div>
              <h4 className="modal-title mb-3 text-center">Are you sure?</h4>
              <h6 className="mb-4 text-center">
                Do you want to delete this User ? <br />You could loss their 
                 <span className="text-primary"> ({getdeletename})</span> related data.
              </h6>
              <div className="d-flex btn-group">
                <button
                  type="button"
                  className="btn btn-secondary btn-sm flex-grow-1"
                  onClick={handleCloseModal}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-danger btn-sm flex-grow-1 mx-2"
                  onClick={handleDelete}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {(showModal || updateModal || deleteShowModals) && (
        <div className="modal-backdrop fade show"></div>
      )}
    </>
  );
}

export default User;